import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { AddressService } from '../../../core/services/address/address/address.service'
import { MatProgressBar } from '@angular/material/progress-bar'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import {
  convertCurrency,
  responseDefaultForm,
  validTreatList,
} from '../../../shared/utils/utils'
import { MatTooltip } from '@angular/material/tooltip'
import { NgClass, NgIf } from '@angular/common'
import { MatDivider } from '@angular/material/divider'
import { ServiceAdditionalProposalFormEditComponent } from './service-additional-proposal-form-edit/service-additional-proposal-form-edit.component'
import { ServiceAdditionalProposalService } from '../../../core/services/service/service-additional-proposal/service-additional-proposal.service'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

@Component({
  selector: 'service-additional-proposal-edit',
  imports: [
    MatInputModule,
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatIcon,
    MatPaginator,
    MatRow,
    MatTable,
    MatTableModule,
    MatIcon,
    MatPaginatorModule,
    MatTable,
    MatProgressBar,
    FormClientSearchComponent,
    MatTooltip,
    NgClass,
    MatDivider,
    ServiceAdditionalProposalFormEditComponent,
    ServiceAdditionalProposalFormEditComponent,
    MatProgressSpinner,
    NgIf,
  ],
  templateUrl: './service-additional-proposal-edit.component.html',
  styleUrl: './service-additional-proposal-edit.component.scss',
  providers: [AddressService],
  standalone: true,
})
export class ServiceAdditionalProposalEditComponent
  implements OnInit, AfterViewInit
{
  constructor(
    // private addressService: AddressService,
    private serviceAdditionalProposal: ServiceAdditionalProposalService,
    private snackbar: SnackbarCustomService,
  ) {}

  item: any = {}
  loading = true

  @Output() responseRefresh = new EventEmitter<any>()
  @Input() idProposal = 0
  @Input() proposal: any = {}
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  columns: any[] = [
    {
      keyColumn: 'description',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'priceUnit',
      key: 'valorUnitarioFormatado',
      description: 'Valor Unitário',
    },
    {
      keyColumn: 'amount',
      key: 'quantidade',
      description: 'Quantidade',
    },
    {
      keyColumn: 'tax',
      key: 'taxaFormatada',
      description: 'Taxa',
    },
    {
      keyColumn: 'priceTotal',
      key: 'valorTotalFormatado',
      description: 'Valor Total',
    },
    {
      keyColumn: 'date',
      key: 'dataServico',
      description: 'Data',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true, duplicate: true },
      description: 'Ações',
    },
  ]

  page = 1
  rows = 10
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()

  displayedColumns: string[] = [
    'description',
    'priceUnit',
    'amount',
    'tax',
    'priceTotal',
    'date',
    'action',
  ]

  inputSearchAddress: any = { type: '', search: '' }
  listSearch: any = [
    {
      id: 'tipoEnderecoId',
      description: 'Tipo endereço',
      type: 'number',
      visible: false,
    },
    { id: 'cep', description: 'Cep', type: 'string', visible: false },
    {
      id: 'logradouro',
      description: 'Logradouro',
      type: 'string',
      visible: true,
    },
    { id: 'cidade', description: 'Cidade', type: 'string', visible: true },
    { id: 'estado', description: 'Estado', type: 'string', visible: true },
    { id: 'ativo', description: 'Ativo', type: 'boolean', visible: false },
  ]
  searchForm: any = { search: false, model: {} }

  loadingDuplicate = false

  ngOnInit(): void {
    this.getAddressByPerson()
    if (
      this.proposal.statusPropostaId == 1 ||
      this.proposal.statusPropostaId == 5 ||
      this.proposal.statusPropostaId == 6 ||
      this.proposal.statusPropostaId == 9
    ) {
      const index = this.displayedColumns.findIndex((ele) => {
        return ele == 'action'
      })
      if (index >= 0) {
        this.displayedColumns.splice(index, 1)
      }
    }
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    // if (this.table) {
    //   this.table.renderRows()
    // }
  }

  pageChanged($event: any) {
    this.page = $event.pageIndex + 1
    // this.rows = $event.pageSize
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchAddress()
    } else {
      this.getAddressByPerson()
    }
  }

  getAddressByPerson() {
    this.loading = true
    this.serviceAdditionalProposal
      .listPagedServiceAdditionalByProposalId(
        this.page,
        this.rows,
        this.idProposal,
      )
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchAddress() {
    this.loading = true

    this.serviceAdditionalProposal
      .searchPagedServiceAdditionalProposal(
        this.page,
        this.rows,
        this.searchForm.model,
      )
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  treatResponse(response: any) {
    const list = []
    if (validTreatList(response)) {
      for (const item of response.data) {
        list.push({
          ...item,
          valorUnitarioFormatado: 'R$ ' + convertCurrency(item.valorUnitario),
          taxaFormatada: convertCurrency(item.taxa) + '%',
          valorTotalFormatado: 'R$ ' + convertCurrency(item.valorTotal),
          valorOriginalFormatado: 'R$ ' + convertCurrency(item.valorOriginal),
        })
      }
    }
    this.tableSource = new MatTableDataSource<any>(list)
    this.refreshTable()
  }

  responseForm(response: any): void {
    if (response.refresh) {
      this.uploadList()
    }
    if (response.clear) {
      this.clearItem()
    }
    this.responseRefresh.emit(true)
  }

  updateItem(element: any) {
    this.item = { edit: true, data: element }
  }

  deleteItem(element: any) {
    this.clearItem()
    this.serviceAdditionalProposal
      .removeServiceAdditionalProposal(element.id)
      .subscribe({
        next: (response: any) => {
          this.uploadList()
          this.snackbar.success(response.message)
          this.responseRefresh.emit(true)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.snackbar.success(err.message)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  duplicateItem(element: any) {
    this.loadingDuplicate = true
    this.clearItem()
    this.serviceAdditionalProposal
      .duplicateServiceAdditionalProposal(this.idProposal, element.id)
      .subscribe({
        next: (response: any) => {
          this.uploadList()
          this.snackbar.success(response.message)
          this.responseRefresh.emit(true)
          this.loadingDuplicate = false
        },
        error: (err: ResponseRequestModel) => {
          this.snackbar.success(err.message)
          this.loadingDuplicate = false
        },
        complete: () => {
          this.loadingDuplicate = false
        },
      })
  }

  clearItem() {
    this.item = {}
  }

  createModel(element: any) {
    const model: any = { pessoaId: this.idProposal }
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }

  checkdate(date: any) {
    if (
      this.proposal.dataInicio != '' &&
      this.proposal.dataFim &&
      date &&
      date != ''
    ) {
      const endParsed = new Date(
        this.proposal.dataFim.split('/').reverse().join('-'),
      )
      const startParsed = new Date(
        this.proposal.dataInicio.split('/').reverse().join('-'),
      )
      const dateParsed = new Date(date.split('/').reverse().join('-'))
      if (startParsed <= dateParsed && dateParsed <= endParsed) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }
}
